<template>
  <el-card>
     <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
       <el-form-item>
         <el-input :value="deviceNumber" disabled></el-input>
       </el-form-item>
       <el-form-item prop="dateRange">
         <el-date-picker
           :clearable = "false"
           v-model="searchInfo.dateRange"
           type="daterange"
           range-separator="-"
           value-format="yyyy-MM-dd"
           :picker-options="pickerOptions"
           start-placeholder="开始日期"
           end-placeholder="结束日期">
         </el-date-picker>
       </el-form-item>
       <el-form-item>
         <el-button type="primary" @click="onSearch">查询</el-button>
       </el-form-item>
     </el-form>
     <div>
      <div class="tipBlock">
        <div class="item">
          <div class="icon">
            <div class="img">
              <img src="@/assets/img/iot/icon_yongdian.svg" alt="">
            </div>
          </div>
          <div class="info">
            <span>总耗电量(kW·h)</span><br/>
            <span class="num">{{info.total || '0'}}</span>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <div class="img">
              <img src="@/assets/img/iot/icon_yongdian.svg" alt="">
            </div>
          </div>
          <div class="info">
            <span>日均耗电量(kW·h)</span><br/>
            <span class="num">{{info.avg || '0'}}</span>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <div class="img">
              <img src="@/assets/img/iot/icon_yongdian.svg" alt="">
            </div>
          </div>
          <div class="info">
            <span>日最高耗电量(kW·h)</span><br/>
            <span class="num">{{info.max || '0'}}</span>
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <div class="img">
              <img src="@/assets/img/iot/icon_yongdian.svg" alt="">
            </div>
          </div>
          <div class="info">
            <span>日最低耗电量(kW·h)</span><br/>
            <span class="num">{{info.min || '0'}}</span>
          </div>
        </div>
      </div>
      <div ref="echart" class="echart"></div>
     </div>
   </el-card>
 </template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'ElectronicHistory',
  data () {
    return {
      searchInfo: {
        dateRange: []
      },
      info: {
        total: '',
        avg: '',
        max: '',
        min: ''
      },
      selectTime: 0,
      pickerOptions: {
        // 选中日期后会执行的回调
        onPick: (date) => {
          this.selectTime = date.minDate.getTime()
          if (date.maxDate) {
            this.selectTime = 0
          }
        },
        disabledDate: (time) => {
          if (this.selectTime !== 0) {
            const dayTime = 365 * 24 * 3600 * 1000
            const minTime = this.selectTime - dayTime
            const maxTime = this.selectTime + dayTime
            return time.getTime() >= (Date.now() - 24 * 3600 * 1000) || (time.getTime() < minTime || time.getTime() > maxTime)
          } else {
            return time.getTime() >= (Date.now() - 24 * 3600 * 1000)
          }
        }
      },
      echart: null
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.params.deviceNumber
    }
  },
  created () {
    this.initTime()
    this.onSearch()
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    avgDeviation (enterNum, avg) {
      const num = enterNum ? avg ? (Math.round(Number(enterNum) * 100) - Math.round(Number(avg) * 100)) / 100 : enterNum : '--'
      const value = num === '--' || num === 0 ? '<span>--</span>' : num > 0 ? `<span style="color: #FF603B">+${num}</span>` : `<span style="color: #52C41A">${num}</span>`
      return value
    },
    initTime () {
      const date = new Date()
      const date1 = new Date(date.getTime() - 24 * 60 * 60 * 1000)
      const date2 = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000)
      const val = date1.getFullYear() + '-' + this.addZero(date1.getMonth() + 1) + '-' + this.addZero(date1.getDate())
      const val2 = date2.getFullYear() + '-' + this.addZero(date2.getMonth() + 1) + '-' + this.addZero(date2.getDate())
      this.searchInfo.dateRange = [val2, val]
    },
    addZero (val) {
      return val < 10 ? '0' + val : String(val)
    },
    changeType (type) {
      this.type = type
      this.onSearch()
    },
    getData () {
      this.$axios.get(this.$apis.iot.selectJgCircuitBreakerDataByPage, {
        deviceNumber: this.deviceNumber,
        startDate: this.searchInfo.dateRange[0],
        endDate: this.searchInfo.dateRange[1],
        page: this.page,
        size: this.size
      }).then((res) => {
        this.info = {
          total: res.totalElectric,
          avg: res.averageElectric,
          max: res.maxElectricDay,
          min: res.minElectricDay
        }
        this.draw(res.dates || [], res.electricTrend || [])
      })
    },
    onSearch () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.page = 1
        this.getData()
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },
    draw (xData, yData1) {
      this.$nextTick(() => {
        this.echart = echarts.init(this.$refs.echart)
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: px2vw(80),
            left: px2vw(10),
            right: px2vw(30),
            bottom: 0,
            containLabel: true
          },
          legend: {
            top: px2vw(30),
            left: 0,
            show: true,
            type: 'plain',
            itemGap: px2vw(25),
            itemWidth: px2vw(18),
            icon: 'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z'
          },
          title: {
            text: '耗电分析（kW·h）',
            textStyle: {
              fontSize: px2vw(16),
              fontWeight: 600,
              color: '#000000'
            }
          },
          backgroundColor: 'transparent',
          color: ['#FFC117', '#1AD1B0'],
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: {
                boundaryGap: true
              }
            },
            axisLine: {
              lineStyle: {
                color: '#DDDDDD'
              }
            },
            axisLabel: {
              show: true,
              margin: px2vw(15),
              textStyle: {
                color: '#999999'
              }
            },
            data: xData
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.45)'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.15)'
              }
            }
          },
          series: [{
            name: '耗电量',
            type: 'line',
            symbolSize: 0,
            smooth: true,
            lineStyle: {
              width: px2vw(4),
              shadowBlur: 0,
              shadowColor: 'rgba(255, 193, 23, 0.2)',
              shadowOffsetY: px2vw(20)
            },
            data: yData1
          }]
        }
        this.echart.setOption(option)
      })
    },
    resize () {
      if (this.echart) {
        this.echart.resize()
      }
    }
  }
}
</script>

 <style scoped lang='scss'>

 .el-card {
     height: calc(100vh - 100px);
     .tipBlock {
       display: flex;
       justify-content: space-between;
       .item {
         display: flex;
         justify-content: center;
         align-items: center;
         width: calc(25% - 20px);
         height: 112px;
         background: #FCFCFC;
         border-radius: 2px;
         margin: 12px 0 30px;
         .icon {
           padding: 8px;
           background-color: rgba(44, 142, 255, 0.2);
           border-radius: 50%;
           margin-right: 18px;
           .img {
             display: flex;
             justify-content: center;
             align-items: center;
             width: 54px;
             height: 54px;
             background-color: #2C8EFF;
             border-radius: 50%;
           }
         }
         span {
           font-family: PingFangSC-Medium, PingFang SC;
           font-size: 12px;
           color: #666666;
           line-height: 18px;
           padding-bottom: 5px;
           &.num {
             font-size: 32px;
             font-family: DINAlternate-Bold, DINAlternate;
             color: #2C8EFF;
             line-height: 38px;
           }
         }
         &:nth-child(2){
           .icon {
             background-color: rgba(26, 209, 176, 0.2);
             .img {
               background-color: rgba(26, 209, 176, 1);
             }
           }
           .num {
             color: rgba(26, 209, 176, 1);
           }
         }
         &:nth-child(3){
           .icon {
             background-color: rgba(255, 96, 59, 0.2);
             .img {
               background-color: rgba(255, 96, 59, 1);
             }
           }
           .num {
             color: rgba(255, 96, 59, 1);
           }
         }
         &:nth-child(4){
           .icon {
             background-color: rgba(82, 196, 26, 0.2);
             .img {
               background-color: rgba(82, 196, 26, 1);
             }
           }
           .num {
             color: rgba(82, 196, 26, 1);
           }
         }
       }
     }
     .el-button-group {
       margin-bottom: 20px;
       ::v-deep .el-button {
         min-width: 84px;
       }
     }
     .echart {
       width: 100%;
       height: 430px;
     }
   }
 </style>
